module.exports = __webpack_public_path__ + "img/hongbao_1_20.2e16b671.png";